import React, { Component } from 'react';
import SelectAsyncCustom from './FormControls/SelectAsyncCustom';
import Button from './Button';
import InputText from './InputText';
import TextArea from './Researcher/TextArea';
import * as Constants from '../Constants';

export class ResearcherForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            researcherId: props.researcherId,
            researcher: {
                id: 0,
                name: '',
                email: '',
                phone: '',
                institution: null,
                subInstitution: null,
                position: null,
                labelEntities: [],
                clinicalResearchExperience: null,
                clinicalTrialsExperience: null,
                comment: ''
            },
            submissionSuccess: false,
            submissionError: false,
            loadResearcherError: false,
            type: props.type,
            onSubmitCallback: props.onSubmit,
            dialogOpen: false,
            shouldReloadAois: false,
            addAnotherCallback: props.onAddAnother
        };

        if (props.researcherId > 0) {
            this.loadResearcher(props.researcherId);
        }

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleInputStringChange = this.handleInputStringChange.bind(this);
        this.handleAreasOfInterestChanged = this.handleAreasOfInterestChanged.bind(this);
        this.handleDialogOpen = this.handleDialogOpen.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
        this.renderForm = this.renderForm.bind(this);
    }

    loadResearcher(researcherId) {
        if (!researcherId) {
            console.error('Invalid researcher id:', researcherId);
        }

        var url = new URL('/api/contacts/get-researcher', window.location.origin);
        var fetchParams = { id: researcherId };

        url.search = new URLSearchParams(fetchParams).toString();

        fetch(url)
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.error('Failed to get researcher:', response);
                    this.setState({ loadResearcherError: true });
                }
            })
            .then(json => {
                for (var l of json.labelEntities) {
                    l.value = l.id;
                }
                this.setState({
                    researcher: {
                        id: json.id,
                        name: json.name,
                        email: json.email,
                        phone: json.phone,
                        institution: json.institution,
                        subInstitution: json.subInstitution,
                        position: json.position,
                        labelEntities: json.labelEntities,
                        clinicalResearchExperience: json.clinicalResearchExperience,
                        clinicalTrialsExperience: json.clinicalTrialsExperience,
                        comment: json.comment
                    }
                });
            })
            .catch(err => {
                console.log('Failed to fetch researcher');
                this.setState({ loadResearcherError: true });
            });
    }

    getResearcherId() {
        const params = new URLSearchParams(window.location.search);

        return params.get('id');
    }

    handleFormSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        let researcherData = this.state.researcher;

        console.log('Submit:', researcherData);

        fetch('/api/contacts/save-researcher', {
            method: "POST",
            body: JSON.stringify(researcherData),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then(response => {
            response.json().then(data => {
                if (response.ok) {
                    if (this.state.onSubmitCallback) {
                        this.state.onSubmitCallback(data);
                    }
                    console.log("Submission success", data);
                    this.setState({ submissionSuccess: true });
                } else {
                    console.error("Submission error", response);
                    this.setState({ submissionError: true });
                }
            })
        });
    }

    handleInputStringChange(e) {
        const value = e.target.value;
        const name = e.target.name;

        this.setState((state) => ({
            researcher: {
                ...state.researcher,
                [name]: value
            }
        }));
    }

    handleAreasOfInterestChanged(e) {
        this.setState((state) => ({
            researcher: {
                ...state.researcher,
                labelEntities: e
            }
        }));
    }

    handleDialogOpen = () => {
        this.setState({ dialogOpen: true });
    };

    handleDialogClose = () => {
        this.setState({ dialogOpen: false, shouldReloadAois: !this.state.shouldReloadAois });
    };

    reset = () => {
        this.setState({
            researcher: {
                id: 0,
                name: '',
                email: '',
                phone: '',
                institution: null,
                subInstitution: null,
                position: null,
                labelEntities: null,
                clinicalResearchExperience: null,
                clinicalTrialsExperience: null,
                comment: ''
            },
            submissionSuccess: false,
            submissionError: false,
            loadResearcherError: false,
            researcherId: 0
        });

        if (this.state.addAnotherCallback) {
            this.state.addAnotherCallback();
        }
    };

    renderForm(state) {
        return (
            <form className="container" onSubmit={this.handleFormSubmit}>
                <div className="row">
                    <div className="col">
                        <InputText required name="name" value={this.state.researcher.name} onChange={this.handleInputStringChange} label="Name" />
                    </div>
                    <div className="col">
                        <InputText required name="email" value={this.state.researcher.email} onChange={this.handleInputStringChange} label="Email" />
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <InputText name="phone" value={this.state.researcher.phone} onChange={this.handleInputStringChange} label="Phone" />
                    </div>
                    <div className="col">
                        <SelectAsyncCustom name="position" title="Position" value={this.state.researcher.position} url={'api/contacts/get-label-entity-select-options?category=' + Constants.Position} onChange={option => this.setState({ researcher: { ...this.state.researcher, position: option } })} showManageBtn category={Constants.Position} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <SelectAsyncCustom name="institution" title="College" value={this.state.researcher.institution} url={'api/contacts/get-label-entity-select-options?category=' + Constants.Institution} onChange={option => { console.log(option); this.setState({ researcher: { ...this.state.researcher, institution: option, subInstitution: null } }); console.log(this); }} showManageBtn category={Constants.Institution} />
                    </div>
                    {this.state.researcher.institution &&
                        <div className="col-6">
                        <SelectAsyncCustom name="subInstitution" title="Department" value={this.state.researcher.subInstitution} url={'api/contacts/get-label-entity-select-options-by-parent?parentId=' + this.state.researcher.institution.id} onChange={option => this.setState({ researcher: { ...this.state.researcher, subInstitution: option } })} showManageBtn parent={this.state.researcher.institution} key={JSON.stringify(this.state.researcher.institution.id)} />
                        </div>
                    }
                </div>
                <SelectAsyncCustom name="areasOfInterest" title="Areas Of Interest" value={this.state.researcher.labelEntities} url={'api/contacts/get-label-entity-select-options?category=' + Constants.AreaOfInterest} onChange={this.handleAreasOfInterestChanged} showManageBtn category={Constants.AreaOfInterest} isMulti />
                {/*<div className="row">*/}
                {/*    <div className="col">*/}
                {/*        <SelectAsyncCustom name="clinicalResearchExperience" title="Clinical Research Experience" value={this.state.researcher.clinicalResearchExperience} url={'api/contacts/get-label-entity-select-options?category=' + Constants.ExperienceRating} onChange={option => this.setState({ researcher: { ...this.state.researcher, clinicalResearchExperience: option } })} />*/}
                {/*    </div>*/}
                {/*    <div className="col">*/}
                {/*        <SelectAsyncCustom name="clinicalTrialsExperience" title="Clinical Trials Experience" value={this.state.researcher.clinicalTrialsExperience} url={'api/contacts/get-label-entity-select-options?category=' + Constants.ExperienceRating} onChange={option => this.setState({ researcher: { ...this.state.researcher, clinicalTrialsExperience: option } })} />*/}
                {/*    </div>*/}
                {/*</div>*/}
                <TextArea name="comment" value={this.state.researcher.comment} onChange={this.handleInputStringChange} label="Comments" />

                <div className="form-group">
                    <Button type="submit" className="btn btn-success" label={this.state.researcherId > 0 ? "Update Researcher" : "Add Researcher"}></Button>
                </div>
            </form>
        )
    }

    render() {
        if (this.state.submissionSuccess) {
            return (
                <div className="alert alert-success">
                    <p>{this.state.researcherId > 0 ? "Researcher successfully updated." : "Researcher successfully added!"}</p>
                    {!this.state.researcherId &&
                        <p><button type="button" className="btn btn-outline-info" onClick={this.reset}>Add Another Researcher</button></p>
                    }
                </div>
            );
        }

        if (this.state.submissionError) {
            return (
                <div className="alert alert-danger">
                    <p>Researcher failed to be added! Please try again.</p>
                    <p><a href="/researchers" className="btn btn-info">Return to Researchers List</a></p>
                </div>
            );
        }

        if (this.state.loadResearcherError) {
            return (
                <div className="alert alert-danger">
                    <p>Could not load researcher with ID: {this.getResearcherId()}</p>
                    <p><a href="/researchers" className="btn btn-info">Return to Researchers List</a></p>
                </div>
            );
        }

        return (
            <div>
                {this.renderForm(this.state)}
            </div>
        );
    }
}